(function () {
    'use strict';

    angular.module('jotApp')
        .directive('dashboardFilter', dashboardFilter);

    function dashboardFilter() {
        var directive = {
            restrict: 'E',
            scope: {
                filter: '&',
                fleet: '=',
                objectType: '=',
                removeOptionAll: '=',
                showCondition: '=',
                fleets: '=',
                condition: '='
            },
            template: '<div class="row">\n' +
            '    <div class="col-xs-12">\n' +
            '        <div class="portlet light filter-portlet bordered">\n' +
            '            <div class="portlet-body form">\n' +
            '                <form ng-submit="vm.submit()" class="horizontal-form">\n' +
            '                    <div class="form-body">\n' +
            '                        <div class="row">\n' +
            '                            <div ng-class="vm.showCondition ? \'col-xs-3\' : \'col-xs-5\' ">\n' +
            '                                <div class="form-group">\n' +
            '                                    <ui-select ng-model="vm.fleet" theme="bootstrap" id="fleet_field" on-select="vm.onFleetSelect($item)">\n' +
            '                                        <ui-select-match\n' +
            '                                        placeholder="Select or search a fleet..">\n' +
            '                                        {{$select.selected.fleetName}}\n' +
            '                                        </ui-select-match>\n' +
            '                                        <ui-select-choices repeat="item in vm.fleets | propsFilter: {fleetName: $select.search, fleetDescription: $select.search}">\n' +
            '                                            <div ng-bind-html="item.fleetName | highlight: $select.search"></div>\n' +
            '                                            <small ng-bind-html="item.fleetDescription | highlight: $select.search"></small>\n' +
            '                                        </ui-select-choices>\n' +
            '                                    </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div ng-class="vm.showCondition ? \'col-xs-3\' : \'col-xs-5\' ">\n' +
            '                                <div class="form-group">\n' +
            '                                    <ui-select ng-model="vm.objectType" id="objectType_field" theme="bootstrap">\n' +
            '                                        <ui-select-match\n' +
            '                                            placeholder="Select or search an object type...">\n' +
            '                                            {{$select.selected.objectTypeName}}\n' +
            '                                        </ui-select-match>\n' +
            '                                        <ui-select-choices repeat="item in vm.objectTypes | filter: {objectTypeName: $select.search}">\n' +
            '                                            <div ng-bind-html="item.objectTypeName | highlight: $select.search"></div>\n' +
            '                                        </ui-select-choices>\n' +
            '                                    </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div ng-if="vm.showCondition" class="col-xs-3">\n' +
            '                                <div class="form-group">\n' +
            '                                    <ui-select ng-model="vm.condition" id="condition_field" theme="bootstrap">\n' +
            '                                        <ui-select-match\n' +
                '                                        placeholder="Select or search a condition...">\n' +
            '                                            {{$select.selected.name}}\n' +
            '                                        </ui-select-match>\n' +
            '                                        <ui-select-choices repeat="item in vm.conditions | filter: {name: $select.search}">\n' +
            '                                            <div ng-bind-html="item.name | highlight: $select.search"></div>\n' +
            '                                        </ui-select-choices>\n' +
            '                                    </ui-select>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                            <div class="col-xs-2" >\n' +
            '                                <div class="form-group">\n' +
            '                                    <button type="submit" id="submit_field" class="btn btn-primary">\n' +
            '                                        <span class="fa fa-filter"></span>&nbsp;<span translate="entity.action.filter">Filter</span>\n' +
            '                                    </button>\n' +
            '                                </div>\n' +
            '                            </div>\n' +
            '                        </div>\n' +
            '                    </div>\n' +
            '                </form>\n' +
            '            </div>\n' +
            '        </div>\n' +
            '    </div>\n' +
            '</div>',
            controller: DashboardFilterController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    DashboardFilterController.$inject = ['TabFleets', 'TabObjectTypes', 'TabObjectsConditions'];

    function DashboardFilterController(TabFleets, TabObjectTypes, TabObjectsConditions) {
        var vm = this;
        var allFleet = {
            id: -1,
            fleetName: "All Fleet"
        };
        var allObjectType = {
            id: -1,
            objectTypeName: "All Object Type"
        };
        var allConditions = {
            id: -1,
            name: "All Conditions"
        };
        var mappedObjectType = {};

        vm.objectTypes = [];

        if(vm.showCondition) {
            vm.conditions = TabObjectsConditions.query();
            vm.conditions.$promise.then(function (data) {
                if (!vm.removeOptionAll)
                    data.unshift(allConditions);
                vm.submit();
            });

            if (!vm.condition.name) {
                vm.condition = allConditions;
            }
        } else  {
            vm.condition = allConditions;
        }

        vm.fleets = TabFleets.query({
            page: 0,
            size: 100
        });
        vm.fleets.$promise.then(function (data) {
            if(!vm.removeOptionAll)
                data.unshift(allFleet);
            // vm.fleets = data;
            if(!vm.showCondition)
                vm.submit();
        });

        TabObjectTypes.mapped().$promise.then(function (data) {
            mappedObjectType = JSON.parse(angular.toJson(data));
            mapObjectTypes();

            if(vm.fleets.$promise) {
                vm.fleets.$promise.then(function () {
                    if (vm.fleet.id > 0) {
                        vm.fleets.forEach(function (f) {
                            if (f.id == vm.fleet.id)
                                vm.fleet = f;
                        });
                        if (vm.fleet.fleetName == undefined || vm.fleet.fleetName == null) {
                            vm.fleet = allFleet;
                        }
                    } else  if (vm.removeOptionAll) {
                        vm.fleet = vm.fleets[0];
                        vm.objectTypes = mappedObjectType[vm.fleet.id];
                    } else {
                        vm.fleet = allFleet;
                    }
                });
            }

            vm.objectTypes = mappedObjectType[vm.fleet.id];
            if(vm.fleet.id == undefined || vm.fleet.id == null){
                if(vm.objectTypes == undefined){
                    vm.objectTypes = [];
                }
                vm.objectTypes.push(allObjectType);
            }

            if (vm.objectType.id > 0) {
                vm.objectTypes.forEach(function (o) {
                    if (o.id == vm.objectType.id)
                        vm.objectType = o;
                });
                if (vm.objectType.objectTypeName == undefined || vm.objectType.objectTypeName == null) {
                    vm.objectType=allObjectType;
                }
            } else if(vm.objectTypes != null && vm.objectTypes.length > 0) {
                vm.objectType = vm.objectTypes[0];
            } else
                vm.objectType = allObjectType;
        });

        vm.onFleetSelect = function (fleet) {
            vm.objectTypes = mappedObjectType[fleet.id];
            vm.objectType = {};
            if (vm.objectTypes.length > 0 && !vm.removeOptionAll) {
                vm.objectType = allObjectType;
            } else if(vm.objectTypes.length > 0) {
                vm.objectType = vm.objectTypes[0];
            }
        };

        vm.submit = function () {
            vm.filter({fleet: vm.fleet, objectType: vm.objectType, condition: vm.condition});
        };

        function mapObjectTypes() {
            for (var fleet in mappedObjectType) {
                if (mappedObjectType[fleet].length > 0 && !vm.removeOptionAll) {
                    mappedObjectType[fleet].unshift(allObjectType);
                }
            }

        }



    }

    angular.module('jotApp').filter('propsFilter', function() {
        return function(items, props) {
            var out = [];

            if (angular.isArray(items)) {
                var keys = Object.keys(props);

                items.forEach(function(item) {
                    var itemMatches = false;

                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var text = props[prop].toLowerCase();
                        if (item[prop]) {
                            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                                itemMatches = true;
                                break;
                            }
                        }
                    }

                    if (itemMatches) {
                        out.push(item);
                    }
                });
            } else {
                // Let the output be the input untouched
                out = items;
            }

            return out;
        };
    });
})();

